import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 84px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 60px;
  @media (max-width: 990px) {
    padding: 24px 60px;
  }
  @media (max-width: 700px) {
    padding: 24px 20px;
  }
`;

export const Filters = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FilterWrap = styled.div`
  display: flex;
  gap: 30px;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 26px;

  @media (max-width: 1024px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    max-width: 1280px;
    gap: 26px;
    margin: 0 auto;
  }
`;
